const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CARDS = [
  { key: "openai_chat", n: 1, title: "OpenAI chat", prompt: "Reply with the word OK." },
  { key: "claude_chat", n: 2, title: "Claude chat", prompt: "Reply with the word OK." },
  { key: "gemini_chat", n: 3, title: "Gemini chat", prompt: "Reply with the word OK." },
  { key: "stream_chat", n: 4, title: "Streaming chat", prompt: "Tokens rendered as they arrive" },
  { key: "vision", n: 5, title: "LLM with an image", prompt: "What colour is this?" },
  { key: "openai_image", n: 6, title: "OpenAI image", prompt: "a red apple on a white table" },
  { key: "gemini_image", n: 7, title: "Gemini image · Nano Banana", prompt: "a red apple on a white table" },
  { key: "fal_image", n: 8, title: "fal.ai image", prompt: "Queue submit → poll → result" },
  { key: "tts", n: 9, title: "Text to speech", prompt: "“Connector test complete”" },
  { key: "stt", n: 10, title: "Speech to text", prompt: "Transcribes card 9 audio" },
  { key: "storage", n: 11, title: "Object storage", prompt: "Upload · list · download" },
  { key: "email", n: 12, title: "Email · Resend", prompt: "Send a test email" },
  { key: "push", n: 13, title: "Push · SuprSend", prompt: "Browser web push" },
];

export const fileUrl = (link) => `${process.env.REACT_APP_BACKEND_URL}${link}`;

export async function runOne(key, params) {
  const r = await fetch(`${API}/test/${key}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(params || {}),
  });
  const body = await r.json().catch(() => null);
  if (!r.ok || !body?.status) {
    return { status: "FAIL", http_status: r.status, latency_ms: 0, error: `Backend HTTP ${r.status}: ${JSON.stringify(body)}` };
  }
  return body;
}

export async function runStream(onToken) {
  const r = await fetch(`${API}/test/stream_chat/stream`, { method: "POST" });
  const reader = r.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  let done = null;
  for (;;) {
    const { value, done: end } = await reader.read();
    if (end) break;
    buf += dec.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    for (const p of parts) {
      if (!p.startsWith("data: ")) continue;
      const msg = JSON.parse(p.slice(6));
      if (msg.token !== undefined) onToken(msg.token);
      if (msg.done) done = msg.done;
    }
  }
  return done;
}

export async function runAll(params) {
  const r = await fetch(`${API}/run-all`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(params || {}),
  });
  return r.json();
}

export async function fetchResults() {
  const r = await fetch(`${API}/results`);
  return r.json();
}

export async function askPushPermission() {
  if (!("Notification" in window)) return "unsupported";
  const perm = await Notification.requestPermission();
  if (perm === "granted" && "serviceWorker" in navigator) {
    await navigator.serviceWorker.register("/sw.js").catch(() => null);
  }
  return perm;
}
